<template>
  <div id="BlogMenu">
    <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
      <router-link class="brand" to="/" aria-label="QXBase 首页"><img src="/brand/qxbase-logo-v1.png" alt="QXBase · qxbase.com" width="158" height="48"></router-link>
      <div class="menu-links">
      <el-menu-item index="1"><a href="/" target="_self">首页</a></el-menu-item>
      <el-submenu index="2">
        <template slot="title">独立页面</template>
        <el-menu-item index="2-1"><a href="https://github.com/QXBase" target="_blank" rel="noopener noreferrer">GitHub仓库</a></el-menu-item>
        <el-menu-item index="2-2"><a @click="gotoChat">在线聊天室</a></el-menu-item>
      </el-submenu>
      <el-menu-item index="3" disabled>旗下站点</el-menu-item>
      <el-menu-item index="4" disabled>关于我们</el-menu-item>
      </div>
      <el-menu-item index="5" class="search-item">
        <el-input
            placeholder="请输入内容"
            prefix-icon="el-icon-search"
            v-model="input2"
            @keyup.enter.native="redirectToSearch()">
        </el-input>
      </el-menu-item>
      <div class="account" v-if="this.userName === '未登录'">
        <el-menu-item index="6">
          <el-button type="text" @click="login">
            <el-col :span="12">
              <div class="demo-basic--circle">
                <div class="block">
                  <el-avatar :size="40" :src="circleUrl"></el-avatar>
                </div>
              </div>
            </el-col>
            <a style="padding-left: 3px; position: relative; top: 0.8vw; color: darkgray;">未登录</a>
          </el-button>
        </el-menu-item>
      </div>
      <div class="account" v-else>
        <el-submenu index="6">
          <template slot="title">
            <el-button type="text">
              <el-col :span="2">
                <div class="demo-basic--circle">
                  <div class="block">
                    <el-avatar :size="40" :src="circleUrl"></el-avatar>
                  </div>
                </div>
              </el-col>
              <a class="user-name">{{
                  truncateContent(userName, 7)
                }}</a>
            </el-button>
          </template>
          <el-menu-item index="6-1" @click="$router.push('/personal')">个人中心</el-menu-item>
          <el-menu-item index="6-2" @click="exit">退出登录</el-menu-item>
        </el-submenu>
      </div>
    </el-menu>
  </div>
</template>

<script>
import {userInfo, userLogout} from "@/api/user/user";

export default {
  data() {
    return {
      input2: "",
      activeIndex: '',
      circleUrl: require('@/assets/headImg.png'),
      sizeList: ["large", "medium", "small"],
      user: {},
      userName: '未登录',
      // loginHtml: '<form id="login-form"><label for="email">邮箱：</label><input type="email" id="email" placeholder="Enter your email" required><br><label for="password">密码：</label><input type="password" id="password" placeholder="Enter your password" required></form>',
    }
  },
  created() {
    this.here();
    this.getUser();
  },
  watch: {
    // 监听子组件数据变化
    user(newVal, oldVal) {
      this.$emit('update:user', newVal); // 通过事件向父组件同步数据
    }
  },
  methods: {
    here: function () {
      var path = this.$route.path.trim();
      if (path === '/') {
        this.activeIndex = '1';
      }
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    redirectToSearch: function () {
      // 获取用户输入的内容
      const subject = this.input2;

      if (subject === '') {
        this.$message({
          'type': 'warning',
          'message': '搜索内容不能为空'
        })
        return;
      }

      // 构建跳转链接
      const searchLink = `/search/${subject}`;
      // 获取 URL 中的哈希部分
      const hashFragment = window.location.hash;
      // console.log(hashFragment);
      // 如果你想获取路径中的特定部分，比如 /#/essay/10 中的 "essay"
      const pathSegments = hashFragment.split('/');
      console.log(pathSegments);
      const specificSegment = pathSegments[1];
      if (specificSegment === 'search') {
        // 获取完整的 URL
        const currentURL = window.location.href;

        var modifiedURL = currentURL.replace(/\/#\/.*$/, "/#");
        window.location.replace(modifiedURL + searchLink);
        location.reload();
        return;
      }
      // 使用路由导航到搜索页面
      this.$router.push(searchLink);
    },
    login: function () {
      localStorage.setItem('lastVisitedPage', window.location.href);
      window.location.href = '#/login';

      // this.$confirm(this.loginHtml, '登录', {
      //     dangerouslyUseHTMLString: true,
      //     confirmButtonText: '确认',
      //     cancelButtonText: '取消',
      //     showCancelButton: true,
      // 	center: true,
      //   }).then(({ value }) => {
      // 	  this.$message({
      // 		type: 'success',
      // 		message: '你的邮箱是: ' + value
      // 	  });
      // 	}).catch(() => {
      // 	  this.$message({
      // 		type: 'info',
      // 		message: '取消输入'
      // 	  });
      // 	});
    },
    gotoChat() {
      window.location.href = '#/chat';
    },
    truncateContent(content, max) {
      // 如果内容长度大于 max，则截取前 max 个字符并加上省略号
      if (content.length > max) {
        const plainText = content.replace(/<[^>]*>/g, '');
        return plainText.substring(0, max) + '...';
      }
      // 否则返回原内容
      return content;
    },
    async getUser() {
      userInfo().then(
          (response) => {
            const res = response.data;
            // if (response.data.code !== 0) {
            // 	this.$message({
            // 		message: response.data.err,
            // 		type: 'error'
            // 	});
            // }
            this.user = res.data;
            if (this.user) {
              this.userName = this.user.userName;
              this.$emit("userEvent", this.user);
            }
          }).catch((err) => {
        console.error(err);
      })
    },
    exit: function () {
      userLogout().then((response) => {
        const res = response.data;
        if (res.code === 0) {
          this.$message({
            type: 'success',
            message: '注销登录'
          })
          location.reload();
        } else {
          this.$message({
            type: 'error',
            message: '注销失败'
          })
        }
      }).catch((err) => {
        console.error(err);
      })
    },
  }
}
</script>

<style scoped>
#BlogMenu { position:relative; z-index:5; min-width:0; background:rgba(247,242,233,.88); border-bottom:1px solid rgba(74,53,37,.16); backdrop-filter:blur(14px); }

/deep/ .el-menu-demo { min-height:66px; max-width:1180px; margin:auto; display:flex; align-items:center; background:transparent; border:0; }
.brand{display:flex;align-items:center;flex-shrink:0;margin-right:26px;padding:8px 0}.brand img{display:block;width:158px;height:48px;object-fit:contain}.brand:focus-visible{outline:2px solid #a26437;outline-offset:3px;border-radius:4px}
.menu-links{display:flex;align-items:center;flex:1}
/deep/ .el-menu--horizontal>.el-menu-item,/deep/ .el-menu--horizontal>.el-submenu .el-submenu__title{height:66px;line-height:66px;border:0!important;color:#5c4a3f;font-size:14px;background:transparent!important;padding:0 14px}/deep/ .el-menu--horizontal>.el-menu-item:hover,/deep/ .el-menu--horizontal>.el-submenu:hover .el-submenu__title{color:#a45e32!important}/deep/ .el-menu--horizontal>.el-menu-item.is-active{color:#8c4e2c!important;border-bottom:2px solid #a45e32!important}
.search-item{margin-left:auto!important;width:170px}/deep/ .search-item .el-input__inner{height:34px;border:1px solid #d9cbb9;border-radius:18px;background:#fffaf2;color:#4a3528}.account{margin-left:12px;white-space:nowrap}.account .el-button{padding:0;color:#6b584a}.user-name{padding-left:20px;position:relative;top:6px;color:#6b584a!important}

a {
  text-decoration: none;
}

a:link,
a:visited {
  color: inherit; /* 使用继承的颜色，保持和默认状态相同 */
  /* text-decoration: none; */
}

@media(max-width:900px){.brand{margin-right:12px}.menu-links .el-menu-item:nth-child(n+3),.menu-links .el-submenu{display:none}.search-item{width:125px}.account{margin-left:2px}}
</style>
